import { ComputedRef } from 'vue'

import { ReviewEntryDetail } from '@/domain/entities/review/reviewEntryDetail'
import { ReviewPostEntryDetailViewModel } from '@/presentation/viewmodels/reviewPost/reviewPostEntryDetailViewModel'

export class ReviewPostEntryDetailPresenter {
  private viewModel: ReviewPostEntryDetailViewModel

  constructor(viewModel: ReviewPostEntryDetailViewModel) {
    this.viewModel = viewModel
  }

  get reviewEntryDetailList(): ComputedRef<{ [entryId: string]: ReviewEntryDetail[] }> {
    return this.viewModel.reviewEntryDetailList
  }

  get isLoading(): ComputedRef<boolean> {
    return this.viewModel.isLoading
  }

  get error(): ComputedRef<Error | null> {
    return this.viewModel.error
  }

  async fetchReviewEntryDetailList(entryId: string): Promise<void> {
    if (this.isLoading.value) {
      console.log('Data fetch is already in progress')
      return
    }
    if (this.hasEntryDetailInList(entryId)) {
      console.log('Entry detail is already in the list')
      return
    }
    await this.viewModel.fetchReviewEntryDetailList(entryId)
  }

  hasEntryDetailInList(entryId: string): boolean {
    return this.viewModel.hasEntryDetailInList(entryId)
  }
}
